import { getWorkspaceId } from '../../lib/auth-storage';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { decisionApi, type SimulationResult, type SimulationScenario } from '../../api/decision';

export function SimulationStudioPage() {
  const [sims, setSims] = useState<SimulationScenario[]>([]);
  const [result, setResult] = useState<SimulationResult | null>(null);
  const [name, setName] = useState('');
  const [priceChange, setPriceChange] = useState('5');

  const refresh = () => void decisionApi.listSimulations((getWorkspaceId() ?? '')).then(setSims);

  useEffect(() => { refresh(); }, []);

  const run = async () => {
    const r = await decisionApi.createSimulation({
      name: name || 'What-if simulation',
      parameters: { price_change_pct: parseFloat(priceChange) || 0 },
    });
    setResult(r);
    refresh();
  };

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Simulation Studio</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">What-if analysis, scenario planning and Monte Carlo simulations.</p>
      <Link to="/decision" className="mt-2 inline-block text-sm text-indigo-700 hover:underline dark:text-indigo-400">← Decision Center</Link>
      <div className="mt-6 rounded-xl border p-4 dark:border-slate-700">
        <h2 className="font-medium">Run Simulation</h2>
        <div className="mt-3 flex flex-wrap gap-2">
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Scenario name" className="rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-800" />
          <input value={priceChange} onChange={(e) => setPriceChange(e.target.value)} placeholder="Price change %" className="w-32 rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-800" />
          <button type="button" onClick={run} className="rounded bg-indigo-600 px-4 py-2 text-sm text-white hover:bg-indigo-700">Run</button>
        </div>
        {result && (
          <div className="mt-4 rounded bg-slate-50 p-3 text-sm dark:bg-slate-800">
            <p className="font-medium">Result ({(result.confidence * 100).toFixed(0)}% confidence)</p>
            <p className="mt-1 text-slate-600 dark:text-slate-400">{result.explanation}</p>
            <pre className="mt-2 overflow-x-auto text-xs">{JSON.stringify(result.outcome, null, 2)}</pre>
          </div>
        )}
      </div>
      <div className="mt-6">
        <h2 className="font-medium">Past Simulations ({sims.length})</h2>
        <ul className="mt-2 space-y-2">
          {sims.map((s) => (
            <li key={s.id} className="rounded border px-3 py-2 text-sm dark:border-slate-700">{s.name} · {s.type} · {s.status}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
